var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "system-requirements",
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.mdAndDown ? true : false,
        width: _vm.$vuetify.breakpoint.mdAndDown ? "auto" : "500",
        transition: "dialog-bottom-transition",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "system-requirements-title",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass:
                        "system-requirements-button font-weight-medium text-body-2 ml-3 text-uppercase",
                      attrs: { "aria-label": "System Requirements", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.dialogVisibility(true)
                        },
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("components.menu.systemRequirements")) +
                      "\n      "
                  ),
                  _c("v-icon", { staticClass: "mb-2", attrs: { small: "" } }, [
                    _vm._v("\n        fad fa-exclamation\n      "),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { color: "secondary" } },
            [
              _c(
                "v-toolbar-title",
                { attrs: { id: "system-requirements-title" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.system.title")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { "aria-label": "Close dialog", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogVisibility(false)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("fal fa-times")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-alert",
            { attrs: { type: "info", role: "status", "aria-live": "polite" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("components.system.playableAt")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-card-title", { staticClass: "system-requirements-title" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("components.system.minimumRequirements.title")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "three-line": "", subheader: "" } },
            _vm._l(
              ["os", "cpu", "memory", "gpu", "drive", "softwares"],
              function (section) {
                return _c(
                  "v-list-item",
                  { key: section },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.system.minimumRequirements." +
                                    section +
                                    ".title"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.system.minimumRequirements." +
                                    section +
                                    ".description"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }
            ),
            1
          ),
          _vm._v(" "),
          _c("v-card-title", { staticClass: "system-requirements-title" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("components.system.recommendedRequirements.title")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "three-line": "", subheader: "" } },
            _vm._l(
              ["os", "cpu", "memory", "gpu", "drive", "softwares"],
              function (section) {
                return _c(
                  "v-list-item",
                  { key: section },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.system.recommendedRequirements." +
                                    section +
                                    ".title"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-list-item-subtitle", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.system.recommendedRequirements." +
                                    section +
                                    ".description"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }
            ),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }